export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const GET_USERS = 'GET_USERS';
export const GET_PARTNERS = 'GET_PARTNERS';
export const SHOW_ADVERTISEMENT = 'SHOW_ADVERTISEMENT';
export const GET_LOGIN_ERROR = 'GET_LOGIN_ERROR';
export const GET_LOGIN_CAPTCHA = 'GET_LOGIN_CAPTCHA';
export const GET_REGISTER_ERROR = 'GET_REGISTER_ERROR';
export const GET_POPUP_DATA = 'GET_POPUP_DATA';
export const GET_POPUP_STYLE_DATA = 'GET_POPUP_STYLE_DATA';
export const SET_BANKLIST = 'SET_BANKLIST';
export const SET_AGENCYLIST = 'SET_AGENCYLIST';
export const SET_MARKETNAMELIST = "SET_MARKETNAMELIST";
export const SET_EVENTPARTNAMELIST = "SET_EVENTPARTNAMELIST";
export const SET_ALLUSERDATA = "SET_ALLUSERDATA";
export const SET_SHOWLEFT = "SET_SHOWLEFT";

export const GET_SPORTS_LIST = 'GET_SPORTS_LIST';
export const SET_SCORE_DATA = 'SET_SCORE_DATA';
export const SET_ACTIVE_ID = 'SET_ACTIVE_ID';
export const SET_FILTER_ID = 'SET_FILTER_ID';
export const SET_FILTER_SORT = 'SET_FILTER_SORT';
export const GET_EVENT_COUNT = 'GET_EVENT_COUNT';
export const SET_EVENT_COUNT = 'SET_EVENT_COUNT';
export const SET_LEAGUE_COUNT = 'SET_LEAGUE_COUNT';
export const SET_STORE_EVENT = 'SET_STORE_EVENT';
export const SET_LOCATION = 'SET_LOCATION';
export const SET_LEAGUE = 'SET_LEAGUE';
export const SET_SEARCHVALUE = 'SET_SEARCHVALUE';
export const SET_SEARCHTYPE = 'SET_SEARCHTYPE';
export const SET_SPORTID = 'SET_SPORTID';
export const SET_URL = 'SET_URL';
export const SET_LEVELBETTINGDATA = 'SET_LEVELBETTINGDATA';
export const SET_BET_SETTING = 'SET_BET_SETTING';
export const MARKET_SETTING = 'MARKET_SETTING';
export const BASELINE_SETTING = 'BASELINE_SETTING';
export const SET_PROVIDERID = 'SET_PROVIDERID';
export const SET_RESULT_INFO = 'SET_RESULT_INFO';
export const SET_GAME_RESULT_LIST = 'SET_GAME_RESULT_LIST';
export const SET_SPORTS_SETTING = 'SET_SPORTS_SETTING';
export const GET_BETGAME_TYPE = "GET_BETGAME_TYPE";
export const SET_MARKETSETTING = "SET_MARKETSETTING";
export const SET_SPORTSMARKETINFO = "SET_SPORTSMARKETINFO";
export const SET_CLIKED = "SET_CLIKED";


export const SET_MINIGAME_TYPE = 'SET_MINIGAME_TYPE';
export const GET_POWERBALLBETTINGLIST = 'GET_POWERBALLBETTINGLIST';
export const SET_BETDATA = 'SET_BETDATA';
export const SET_BETTYPE = 'SET_BETTYPE';
export const SET_POWERBALL_RATES = 'SET_POWERBALL_RATES';
export const SET_POWERBALL_BTN_STATUS = 'SET_POWERBALL_BTN_STATUS';
export const SET_MINICHECK = 'SET_MINICHECK';
export const SET_BETTED_ITEMS = 'SET_BETTED_ITEMS';

export const ADD_ONEBET = 'ADD_ONEBET';
export const GET_CURRENT_BETTING = 'GET_CURRENT_BETTING';
export const SET_MUILT = 'SET_MUILT';
export const SET_MAX_VALUE = 'SET_MAX_VALUE';
export const SET_DELAY = 'SET_DELAY';
export const SAMEMARKETALLOW = 'SAMEMARKETALLOW';
export const SET_LIVE_MULTI_ALLOW = 'SET_LIVE_MULTI_ALLOW';

export const SET_PAGE_INFO = 'SET_PAGE_INFO';
export const SET_PAGE_DATA = 'SET_PAGE_DATA';
export const SET_NEW_PAGE_DATA = 'SET_NEW_PAGE_DATA';
export const SET_PAGE_LOAD = 'SET_PAGE_LOAD';
export const SET_PER_PAGE = 'SET_PER_PAGE';
export const SET_CHECK_PAGE = 'SET_CHECK_PAGE';
export const SET_GAMECHECK = 'SET_GAMECHECK';
export const SET_MESSAGE_PAGE = 'SET_MESSAGE_PAGE';
export const SET_REWORD_BONUS_PAGE = 'SET_REWORD_BONUS_PAGE';
export const SET_RECONNECT_SETTING = 'SET_RECONNECT_SETTING';
export const SET_SCROLL_DIRECTION = 'SET_SCROLL_DIRECTION';

export const GET_REALTIMEEXCHANGEDATA = 'GET_REALTIMEEXCHANGEDATA';
export const GET_REALTIME_DEPOSITE = 'GET_REALTIME_DEPOSITE';
export const GET_REALTIME_WITHDRAW = 'GET_REALTIME_WITHDRAW';
export const GET_MESSAGEDATA = 'GET_MESSAGEDATA';
export const GET_DEPOSITDATA = 'GET_DEPOSITDATA';
export const GET_DEPOSIT_SUM = 'GET_DEPOSIT_SUM';
export const GET_POINT_HISTORY = 'GET_POINT_HISTORY';
export const GET_EXCHANGEDATA = 'GET_EXCHANGEDATA';
export const GET_DAILYCHECK_HISTORY = 'GET_DAILYCHECK_HISTORY';
export const GET_DAILYCHECK_INFO = 'GET_DAILYCHECK_INFO';
export const GET_LOTTERY_DATA = 'GET_LOTTERY_DATA';
export const GET_ROULETTE_DATA = 'GET_ROULETTE_DATA';
export const GET_ROULETTE_RULES = 'GET_ROULETTE_RULES';
export const GET_COUPON_LIST = 'GET_COUPON_LIST';
export const GET_EVENT_TYPE = 'GET_EVENT_TYPE';
export const GET_EVENT_LIST = 'GET_EVENT_LIST';
export const GET_NOTICES = 'GET_NOTICES';
export const GET_WITHDRAW_SUM = 'GET_WITHDRAW_SUM';
export const GET_WITHDRAWDATA = 'GET_WITHDRAWDATA';
export const GET_HISTORIES = 'GET_HISTORIES';
export const GET_QUESTION_LIST = 'GET_QUESTION_LIST';
export const GET_BLOG_LIST = 'GET_BLOG_LIST';
export const SET_DETAIL_NOTICE = "SET_DETAIL_NOTICE";
export const SET_DETAIL_EVENT = "SET_DETAIL_EVENT";
export const GET_BONUS = "GET_BONUS";
export const SET_ALLMINIDATA = "SET_ALLMINIDATA";
export const SET_DETAIL_NOTICE_CONTENT = "SET_DETAIL_NOTICE_CONTENT";
export const SET_DETAIL_EVENT_CONTENT = "SET_DETAIL_EVENT_CONTENT";
export const GET_REWORD_INFO = "GET_REWORD_INFO";
export const GET_REWORD_BETTING_AMOUNT = "GET_REWORD_BETTING_AMOUNT";
export const GET_REWORD_REMAIN_COUNT = "GET_REWORD_REMAIN_COUNT";
export const GET_AWARDED_LIST = "GET_AWARDED_LIST";
export const SET_BOARD_HISTORY = "SET_BOARD_HISTORY";
export const SET_BOARD_HISTORY_TYPE = "SET_BOARD_HISTORY_TYPE";
export const GET_EXCHANGESETTING = "GET_EXCHANGESETTING";



// WEBPACK FOOTER //
// ./src/common/actions/types.js